import { render, staticRenderFns } from "./TransferDetailOfBigAmount.vue?vue&type=template&id=2b343727&scoped=true"
import script from "./TransferDetailOfBigAmount.vue?vue&type=script&lang=js"
export * from "./TransferDetailOfBigAmount.vue?vue&type=script&lang=js"
import style0 from "./TransferDetailOfBigAmount.vue?vue&type=style&index=0&id=2b343727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b343727",
  null
  
)

export default component.exports